import {useState} from "react";
import {App as AntdApp, Input} from "antd";
import className from "classnames/bind";
import {Button, FontAwesomeIcon, PageHeader} from "~/components";
import {rtkErrorMessage} from "~/reduxs/api/apiSlice";
import {useValidateSchemaMutation} from "~/reduxs/api/schemaApiSlice";
import ValidationResult from "../components/ValidationResult";
import style from "../style/SchemaTool.module.scss";

const cn = className.bind(style);

const SAMPLE = `{
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Tên sản phẩm",
  "image": "https://example.com/anh.jpg",
  "offers": {
    "@type": "Offer",
    "price": "199000",
    "priceCurrency": "VND"
  }
}`;

/**
 * Trang Validator: dán JSON-LD → BE validate 3 lớp → hiển thị lỗi/cảnh báo + khả
 * năng đủ điều kiện rich result.
 */
function SchemaValidator() {

	const {notification} = AntdApp.useApp();

	const [json, setJson] = useState('');
	const [result, setResult] = useState(null);

	const [validateSchema, {isLoading}] = useValidateSchemaMutation();

	const handleValidate = async () => {
		if (!json.trim()) {
			notification.warning({message: 'Chưa có nội dung', description: 'Vui lòng dán JSON-LD cần kiểm tra'});
			return;
		}
		try {
			const data = await validateSchema(json).unwrap();
			setResult(data);
		} catch (e) {
			notification.error({message: 'Lỗi', description: rtkErrorMessage(e, 'Kiểm tra thất bại')});
		}
	};

	return (
		<div className="container">
			<PageHeader
				icon="fa-light fa-shield-check"
				title="Kiểm tra Schema (JSON-LD)"
				subtitle="Kiểm tra cú pháp, vocabulary schema.org và luật rich result của Google"
				actions={
					<Button to="/schema/generator" white
						leftIcon={<FontAwesomeIcon icon="fa-light fa-shapes" />}>
						Tạo mới
					</Button>
				}
			/>

			<div className={cn('validator')}>
				<Input.TextArea
					value={json}
					onChange={(e) => setJson(e.target.value)}
					placeholder="Dán đoạn JSON-LD vào đây…"
					rows={14}
					className={cn('validator-input')}
				/>
				<div className={cn('validator-actions')}>
					<Button primary onClick={handleValidate} loading={isLoading}
						leftIcon={<FontAwesomeIcon icon="fa-light fa-shield-check" />}>
						Kiểm tra
					</Button>
					<Button outline onClick={() => setJson(SAMPLE)}
						leftIcon={<FontAwesomeIcon icon="fa-light fa-flask" />}>
						Dùng ví dụ
					</Button>
				</div>
			</div>

			{isLoading ? (
				<div className={cn('loading')}>
					<span className="app-spinner" />
					<p>Đang kiểm tra…</p>
				</div>
			) : <ValidationResult result={result} />}
		</div>
	);
}

export default SchemaValidator;
